import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/setQuarter/index.js';

var require$$32 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$32 as default };
